<template>
  <main class="activities">
    <Info class="u-hidden--from-ipadP" :allways="true"/>
    <transition-group
      @enter="enter"
      tag="section"
      appear
    >
      <article
        class="activities__block"
        v-for="(item, i) in activities.list"
        :key="`venuse-${i}`"
        data-item
      >
        <div class="block__container">
          <AppTitle
            class="c-title--light"
            :data="{ content: item.data.title }"
            :isAnimated="false"
            data-lazyanimation="title"
          />
          <AppLine
            class="block__line"
            data-lazyanimation="line" :isSmall="true" :isAnimated="false"
          />
          <AppTitle
            class="c-title--dark"
            :data="{ content: item.data.subTitle }"
            :isAnimated="false"
            data-lazyanimation="title"
          />
          <AppLine
            class="block__line"
            data-lazyanimation="line" :isSmall="true" :isAnimated="false"
          />
          <a
            :href="item.data.mapsLink"
            @mouseenter="$eventHub.$emit('textCursor', 'View on Google Map')"
            @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
            target="_blank"
            rel="noopener"
          >
            <AppTitle
              class="block__marquee"
              :data="{ content: item.data.address }"
              type="marquee"
              :isAnimated="false"
              data-lazyanimation="title"
            />
          </a>
          <AppLine
            class="block__line"
            data-lazyanimation="line" :isSmall="true" :isAnimated="false"
          />
          <a
            :href="item.data.mapsLink"
            class="block__picture-cont"
            @mouseenter="$eventHub.$emit('textCursor', 'View on Google Maps')"
            @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
            target="_blank"
            rel="noopener"
          >
            <AppPicture
              class="block__picture"
              :data="{ src: item.data.picture, alt: item.data.pictureAlt }"
              :lazy="true"
              :isImg="false"
              :isAnimated="false"
              data-lazyanimation="picture"
            />
            <div
              class="block__picture-link"
            >
              <svg
                viewBox="0 0 100 100"
              >
                <circle
                  cx="50" cy="50" r="50"
                />
              </svg>
              <span>
                View on Google Maps
              </span>
            </div>
          </a>
          <AppParagraph
            v-if="item.data.description !== ''"
            class="block__content"
            :data="{ content: item.data.description }"
            data-lazyanimation="fade"
          />
        </div>
      </article>
    </transition-group>

    <AppSponsor class="activities__sponsor"/>

    <AppFooter />
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

import AppLine from '@/components/AppLine.vue';
import AppTitle from '@/components/AppTitle.vue';
import AppParagraph from '@/components/AppParagraph.vue';
import AppPicture from '@/components/AppPicture.vue';
import AppSponsor from '@/components/AppSponsor.vue';
import AppFooter from '@/components/AppFooter.vue';
import Info from '@/components/Info.vue';

import medusa from '@/scripts/medusa';
import { initials } from '@/scripts/fx';

import activitiesList from '@/assets/data/contents/activities.json';

export default {
  name: 'Activities',
  components: {
    AppLine,
    AppTitle,
    AppParagraph,
    AppPicture,
    AppSponsor,
    AppFooter,
    Info,
  },
  data() {
    return {
      activitiesList,
    };
  },
  computed: {
    ...mapGetters(['currentPage', 'contentReady']),

    activities() {
      return this.activitiesList[this.$route.params.city];
    },
  },
  mounted() {
    medusa.recalculateTargets(this.$el);
  },
  methods: {
    enter(el, done) {
      const items = [...el.querySelectorAll('[data-lazyanimation="fade"]')];
      const titles = [...el.querySelectorAll('[data-lazyanimation="title"] h3')];
      const lines = [...el.querySelectorAll('[data-lazyanimation="line"]')];
      const pictures = [...el.querySelectorAll('[data-lazyanimation="picture"]')];
      items.forEach(item => initials.get('fade')(item, 80));
      titles.forEach(title => initials.get('title')(title));
      lines.forEach(line => initials.get('line')(line));
      pictures.forEach(picture => initials.get('picture')(picture));
      medusa.ref.pushToTarget('scrollAnimations', items);
      medusa.ref.pushToTarget('scrollAnimations', titles);
      medusa.ref.pushToTarget('scrollAnimations', lines);
      medusa.ref.pushToTarget('scrollAnimations', pictures);
      medusa.prevNodes.push(...items);
      medusa.prevNodes.push(...titles);
      medusa.prevNodes.push(...lines);
      medusa.prevNodes.push(...pictures);

      done();
    },
  },
  beforeDestroy() {
    medusa.removePrevTargets();
  },
};
</script>

<style lang="scss" scoped>
.activities {
  .info {
    position: relative;
    top: unset;
    width: 100%;

    transform: translateY($unit-vh * -2);
    z-index: unset;
  }

  &__sponsor {
    margin-top: $unit-vh * 8;

    @include mq(ipadP) {
      margin-top: $unit-vh * 6;
    }

    @include mq(ds) {
      margin-top: $unit-vh * 12;
    }
  }

  &__block {
    position: relative;
    min-height: 100vh;
    margin-top: $unit-vh * 8;

    pointer-events: none;

    &:first-of-type {
      margin-top: 0;
    }

    @include mq(ipadP) {
      margin-top: $unit-vh * 6;
    }

    @include mq(ds) {
      margin-top: $unit-vh * 12;
    }

    a {
      display: block;
      pointer-events: all;

      cursor: none;
    }
  }


  .c-title--light,
  .c-title--dark,
  .block__line,
  .block__marquee {
    z-index: 5;
  }

  .block__content {
    width: 100%;
    pointer-events: none;

    @include mq(ipadP) {
      width: $unit-vw * 16;
    }
  }

  .block__picture-cont {
    position: relative;
    margin: 80px 0 40px;

    @include mq(ipadP) {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
    }
  }

  .block__picture {
    position: relative;
    width: 100%;
    opacity: 0.3;

    @include aspect-ratio(3, 4);

    @include mq(ipadP) {
      width: $unit-vw * 36;
      margin: 0;
    }

    @include mq(ipadL) {
      width: $unit-vw * 28;
      margin-top: $unit-vh * 4;
    }
  }

  .block__picture-link {
    display: inline-block;
    position: relative;
    top: -100px;
    left: 0;
    width: 100%;
    margin-bottom: -100px;

    text-align: center;
    z-index: 5;

    @include mq($and: $is-not-touch-device) {
      display: none;
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }

    svg {
      max-width: 200px;

      circle {
        fill: var(--color-cursor);
      }
    }
  }
}
</style>
<style lang="scss">
.activities__block {
  @include mq($and: $is-not-touch-device) {
    & a .picture__img {
      opacity: 0.7;
      transition: transform .4s $outCirc,
        opacity .4s $outBack;
    }
    & a:hover .picture__img {
      opacity: 1;
      transform: scale(1.1);
      transition: transform .4s $outBack,
        opacity .4s $outBack
    }
  }
}
</style>
